import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import type { AnalyticsMetaData } from 'state/actions/search';
import { showSearch, search, resetSearch as resetSearchAction } from 'state/actions/search';
import {
    getShown,
    getTerm,
    getSearchResults,
    getIsSearching,
    hasSearchResultError,
    getQueryTime,
    getSearchStartTime,
    getIsSearchingRequestTypes,
    getIsSearchingPortals,
    getIsSearchingKb,
} from 'state/selectors/search';
import { PortalAnalyticsModal } from '@atlassian/help-center-common-util/analytics';
import { withPathParams } from '@atlassian/help-center-common-component/with-path-params';
import { fetchHelpCenterAction } from 'epics/model/help-center';
import { fetchPortalAction } from 'state/actions/portal';
import type { Props } from './search-modal';
import { ModalWithFetcher } from './search-modal';
import { withAnalyticsEvents, withAnalyticsContext } from '@atlaskit/analytics-next';

const selector = createSelector(
    getShown,
    getTerm,
    getQueryTime,
    getSearchResults,
    getSearchStartTime,
    getIsSearching,
    getIsSearchingPortals,
    getIsSearchingRequestTypes,
    getIsSearchingKb,
    hasSearchResultError,
    (
        shown,
        term,
        queryTime,
        result,
        searchStartTime,
        isSearching,
        isSearchingPortals,
        isSearchingRequestTypes,
        isSearchingKb,
        hasError
    ) => ({
        shown,
        term,
        queryTime,
        result,
        searchStartTime,
        isSearching,
        isSearchingPortals,
        isSearchingRequestTypes,
        isSearchingKb,
        hasError,
    })
);

export const SearchModal = connect(selector, {
    onChange: (term: string, meta: AnalyticsMetaData) => search(term, {}, meta),
    onRequestClose: () => showSearch(false),
    fetchPortal: fetchPortalAction,
    resetSearch: resetSearchAction,
    fetchHelpCenter: fetchHelpCenterAction,
})(
    PortalAnalyticsModal<Props>('portalSearch')(
        withPathParams(withAnalyticsContext({ componentName: 'PortalSearch' })(withAnalyticsEvents()(ModalWithFetcher)))
    )
);
